<template>
  <div id="help">
    <div class="row">
      <div class="col-12 col-sm-6 col-md-6">
        <div class="breadcrumbs">
          <p :lang=selectedLanguageCode>{{ $t('message.you-are-here') }}</p>
          <ul>
            <li>
              <router-link tag="a" to="/">{{ $t('message.LEXIN') }}</router-link>
            </li>
            <li>
              <font-awesome-icon icon="arrow-right" class="right-agap"/>
              <span>{{ $t('message.help') }}</span>
            </li>
          </ul>
        </div>
      </div>
      <Language class="col-12 col-sm-6 col-md-6"></Language>
    </div>
    <div class="row">
      <div class="col-12">
        <h1>
          <span>{{ $t('message.help') }}</span>
        </h1>
        <div class="clearfix"></div>
        <div class="home-info">
          <p>{{ $t('message.font-help-paragraph-1') }}</p>
          <a
            href="mailto:lexin@oslomet.no"
          >{{ $t('message.font-help-paragraph-2') }}</a>
          <ol style="list-style-type: disc">
            <li>
              <a
                target="_blank"
                href="http://kurditgroup.org/downloads"
              >{{ $t('message.download-kurdish-font') }}</a>
            </li>
            <li>
              <a
                target="_blank"
                href="/lexin/fonts/Kalaiva.ttf"
                download
              >{{ $t('message.download-tamil-font') }}</a>
            </li>
            <li>
              <a
                target="_blank"
                href="/lexin/fonts/gfzemenu.ttf"
                download
              >{{ $t('message.download-tigrinya-font') }}</a>
            </li>
          </ol>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Language from "./Language.vue";
export default {
  name: "HelpComponent",
  data() {
    return {
       languageCodeList:[
        {lang:'eng',langISOCode:'en'},
        {lang:'nny',langISOCode:'nn'},
        {lang:'nbo',langISOCode:'nb'}
      ]
    }
  },
  computed: {
    selectedLanguageCode () {
      return this.languageCodeList.find(x=>x.lang==localStorage.getItem('lang')).langISOCode;
    },
  },
  components: {
    Language
  },
  created() {
    $("body,html").animate(
      {
        scrollTop: 0
      },
      60
    );
  }
};
</script>
